// Mock data for Casagrande Brinquedos clone
// NOTE: All data below is mocked on the frontend for now.

export const WHATSAPP_NUMBER = "5547996659371";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=Ol%C3%A1!%20Gostaria%20de%20pedir%20um%20or%C3%A7amento.`;
export const LOGO_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_fun-landing/artifacts/t8s1pj9k_78169.png";

export const navItems = [
  { label: "Início", href: "#inicio" },
  { label: "Brinquedos", href: "#brinquedos" },
  { label: "Como funciona", href: "#como-funciona" },
  { label: "Sobre nós", href: "#sobre" },
  { label: "Galeria", href: "#galeria" },
  { label: "FAQ", href: "#faq" },
  { label: "Contato", href: "#contato" },
];

export const heroHighlights = [
  { icon: "ShieldCheck", text: "Higiene em cada evento" },
  { icon: "Truck", text: "Entrega e montagem" },
  { icon: "MapPin", text: "Atendimento de pertinho" },
];

export const features = [
  {
    icon: "PartyPopper",
    title: "Diversão",
    desc: "Brinquedos para diferentes idades e tipos de evento.",
    color: "#ec4899",
  },
  {
    icon: "ShieldCheck",
    title: "Segurança",
    desc: "Equipamentos preparados para proporcionar diversão com segurança.",
    color: "#38bdf8",
  },
  {
    icon: "Sparkles",
    title: "Qualidade",
    desc: "Atendimento profissional e cuidado em cada detalhe.",
    color: "#f59e0b",
  },
  {
    icon: "Truck",
    title: "Comodidade",
    desc: "Entregamos, montamos e retiramos os brinquedos.",
    color: "#22c55e",
  },
];

export const categories = [
  "Todos",
  "Infláveis",
  "Cama elásticas",
  "Jogos",
  "Serviços",
  "Mais procurados",
];

export const products = [
  {
    id: 1,
    name: "Cubo Mágico 3 em 1",
    category: "Infláveis",
    featured: true,
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_fun-landing/artifacts/zbw0i7fh_89E77B6E-B2BA-489F-A560-BB29CD5A71FE.png",
  },
  {
    id: 2,
    name: "Pula Pula Premium 2,44m",
    category: "Cama elásticas",
    featured: true,
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_fun-landing/artifacts/agqwv439_914CBBDD-930B-436F-B4FD-4AF096BF4504.png",
  },
  {
    id: 3,
    name: "Dual Nerf + Corrida Maluca",
    category: "Jogos",
    featured: true,
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_fun-landing/artifacts/nutkf4pq_AB849A23-7ABB-491B-8A76-E88E0E5DE400.png",
  },
  {
    id: 4,
    name: "Air Soccer",
    category: "Jogos",
    featured: true,
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_fun-landing/artifacts/ypl5hzje_438EB204-1A8B-4F26-BE92-3C3B56560F59.png",
  },
  {
    id: 5,
    name: "Recreação com Pintura",
    category: "Jogos",
    featured: false,
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_fun-landing/artifacts/3f7ailgz_A6895AE7-352A-44EF-B0E8-0C371D3EF794.png",
  },
  {
    id: 6,
    name: "Piscina de Bolinhas UNO",
    category: "Infláveis",
    featured: true,
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_fun-landing/artifacts/1o1cu72l_FC838BC3-AD64-4750-850B-717312B5F63C.png",
  },
  {
    id: 7,
    name: "Mini Escorrega",
    category: "Infláveis",
    featured: false,
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_fun-landing/artifacts/6rk2i14a_045E5E5A-8846-442E-BF43-40C1A56929FE.png",
  },
  {
    id: 8,
    name: "Fut-Sabão",
    category: "Jogos",
    featured: false,
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_fun-landing/artifacts/9a6usar9_076DDCBB-3FB5-4586-8FA6-86AF7CA2EA71.png",
  },
  {
    id: 9,
    name: "Canhão de Espuma",
    category: "Jogos",
    featured: true,
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_fun-landing/artifacts/jztcbnjn_A192A8AE-1BFB-43B1-84AA-2981737B1713.png",
  },
  {
    id: 10,
    name: "Pacote Mídia com Drone",
    category: "Serviços",
    featured: true,
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_fun-landing/artifacts/clqmmvgj_1267BB7E-0788-493A-A5F0-42CCA45CA3D5.png",
  },
  {
    id: 11,
    name: "Castelinho Escorrega com Piscina de Bolinhas",
    category: "Infláveis",
    featured: true,
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_fun-landing/artifacts/hvhbsn5k_147EF99E-3089-4E24-AEEE-DC2B9C53E888.png",
  },
  {
    id: 12,
    name: "Pula Pula Premium 3,5m",
    category: "Cama elásticas",
    featured: true,
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_fun-landing/artifacts/h5u9jvmm_0CA0161D-69EF-4FDE-BA9F-9C1403D1D1EF.png",
  },
  {
    id: 13,
    name: "Tobogã",
    category: "Infláveis",
    featured: true,
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_fun-landing/artifacts/y4r9g2jb_BB009467-EE64-4410-B513-2F101B9D2ADA.png",
  },
];

export const aboutInfo = {
  label: "Quem faz a festa acontecer",
  title: "Prazer, somos a Casagrande Brinquedos",
  text: "Trabalhamos para tornar cada festa ainda mais especial. Nosso objetivo é levar diversão, praticidade e momentos inesquecíveis para crianças e famílias.",
  cta: "Falar com a gente",
  image:
    "https://images.unsplash.com/photo-1621354598022-16599af1b8b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxjaGlsZHJlbiUyMHBsYXlpbmclMjBwYXJ0eXxlbnwwfHx8fDE3OTA4MzgwODJ8MA&ixlib=rb-4.1.0&q=85",
  bullets: [
    {
      icon: "ShieldCheck",
      title: "Cuidado e higiene",
      desc: "Brinquedos higienizados antes de cada evento, porque a saúde das crianças vem primeiro.",
    },
    {
      icon: "Truck",
      title: "Zero preocupação",
      desc: "Entregamos, montamos e retiramos tudo. Você só se preocupa em aproveitar.",
    },
    {
      icon: "Heart",
      title: "Atendimento de pertinho",
      desc: "Você fala direto com a gente, com atenção e carinho em cada detalhe da sua festa.",
    },
  ],
};

export const howItWorks = [
  {
    step: "01",
    icon: "MousePointerClick",
    title: "Escolha os brinquedos",
    desc: "Navegue pelo nosso catálogo e selecione os brinquedos ideais para o seu evento.",
  },
  {
    step: "02",
    icon: "MessageCircle",
    title: "Peça o orçamento",
    desc: "Fale com a gente pelo WhatsApp e receba um orçamento rápido e sem compromisso.",
  },
  {
    step: "03",
    icon: "CalendarCheck",
    title: "Agende a data",
    desc: "Confirmamos a disponibilidade e reservamos os brinquedos para o dia do seu evento.",
  },
  {
    step: "04",
    icon: "Truck",
    title: "Relaxe e aproveite",
    desc: "Entregamos, montamos, higienizamos e retiramos tudo. Você só curte a festa!",
  },
];

export const aboutStats = [
  { value: "+500", label: "Eventos realizados" },
  { value: "+30", label: "Brinquedos no catálogo" },
  { value: "100%", label: "Higienização garantida" },
  { value: "+8", label: "Anos de experiência" },
];

export const gallery = [
  "https://images.unsplash.com/photo-1608790672275-309c02d888ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxraWRzJTIwYmlydGhkYXklMjBwYXJ0eXxlbnwwfHx8fDE3OTA4MzgwODJ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1509666537727-9154b6962292?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHxraWRzJTIwYmlydGhkYXklMjBwYXJ0eXxlbnwwfHx8fDE3OTA4MzgwODJ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/8104171/pexels-photo-8104171.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/7600383/pexels-photo-7600383.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1621354598022-16599af1b8b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxjaGlsZHJlbiUyMHBsYXlpbmclMjBwYXJ0eXxlbnwwfHx8fDE3OTA4MzgwODJ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1614113036347-9f60df80730a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxjaGlsZHJlbiUyMHBsYXlpbmclMjBwYXJ0eXxlbnwwfHx8fDE3OTA4MzgwODJ8MA&ixlib=rb-4.1.0&q=85",
];

export const eventTypes = [
  "Aniversário infantil",
  "Festa infantil",
  "Evento corporativo",
  "Escola / Creche",
  "Condomínio",
  "Confraternização",
  "Outro",
];

export const faqs = [
  {
    q: "Como funciona a locação dos brinquedos?",
    a: "Você escolhe os brinquedos no catálogo, solicita o orçamento pelo WhatsApp e nós cuidamos da entrega, montagem e retirada no dia do seu evento.",
  },
  {
    q: "Vocês fazem a entrega e montagem?",
    a: "Sim! A entrega, montagem e retirada estão inclusas no serviço. Você não precisa se preocupar com nada.",
  },
  {
    q: "Os brinquedos são higienizados?",
    a: "Todos os brinquedos passam por higienização completa antes de cada evento, garantindo a segurança das crianças.",
  },
  {
    q: "Qual a antecedência para reservar?",
    a: "Recomendamos reservar com pelo menos 7 dias de antecedência para garantir a disponibilidade dos brinquedos na data desejada.",
  },
  {
    q: "Quais formas de pagamento vocês aceitam?",
    a: "Aceitamos PIX, cartão de crédito, débito e dinheiro. As condições são combinadas no momento do orçamento.",
  },
  {
    q: "Atendem eventos corporativos e escolas?",
    a: "Sim! Atendemos aniversários, festas infantis, eventos corporativos, escolas, condomínios e comemorações especiais.",
  },
];

export const contactInfo = {
  owner: "Bianca Casagrande",
  tagline: "Brinquedos e diversão para momentos inesquecíveis.",
  phone: "(47) 99665-9371",
  address: "Atendemos Balneário Camboriú e região",
  hours: "Seg a Sáb, 8h às 18h",
  social: [
    { icon: "MessageCircle", label: "WhatsApp", href: WHATSAPP_LINK },
    {
      icon: "Instagram",
      label: "Instagram",
      href: "https://instagram.com/casagrande_brinquedos",
    },
  ],
};
